import React, { Component } from "react";
import Select from "react-select";

export default class HcsFlyoutShoppingBasket extends Component {
    constructor(props) {
        super(props);

        this.enabled = props.availablePriceTypes ? true : false;
        this.options = [];

        if(this.enabled) {
            this.options = props.availablePriceTypes.map(item => {
                return {
                    value: item,
                    label: props.hcs.t.gui("Price_" + item)
                };
            });
        }

        this.state = {
            priceType: props.priceType
        };

        this.guid = new Date().getTime();

        this.valueChanged = this.valueChanged.bind(this);
    }

    valueChanged(selectedItem) {
        const { priceTypeChanged } = this.props;

        if(selectedItem.value !== this.state.priceType) {
            this.priceType = selectedItem.value;

            priceTypeChanged.call(this, selectedItem.value);
        }
    }

    /**
     * Returns ID of the currently selected price type.
     * @returns {string} ID of the currently selected price type.
     */
    get priceType() {
        return this.state.priceType;
    }

    /**
     * Set ID for the new price type value to be selected.
     * @param {string} [newPriceType] - Set ID for the new price type value to be selected.
     */
    set priceType(newPriceType) {
        this.setState({
            priceType: newPriceType
        });
    }

    render() {
        const { priceType } = this.state;

        return (
            <Select
                key={this.guid + "_" + priceType}
                options={this.options}
                defaultValue={this.options.find((item) => { return item.value === priceType; })}
                onChange={this.valueChanged}
                className="hcs-fsb-select"
                classNamePrefix="select"
                isSearchable={false}
                menuPosition="fixed"
                placeholder=" "
            />);
    }
}